import React, { useCallback, VFC } from 'react';
import { resetBridge } from '../redux/slices/bridgeSlice';
import { resetWallet } from '../redux/slices/walletSlice';
import Modal from './common/Modal/Modal';
import {
  reset as resetModal,
  selectModalSlice,
} from '../redux/slices/modalSlice';
import { logout } from '../redux/slices/kstadiumSlice';
import { useAppDispatch, useAppSelector } from '../hooks';
import Button from './common/Button/Button';

const ModalTimeoutLogout: VFC = () => {
  const dispatch = useAppDispatch();
  const { modalShowing } = useAppSelector(selectModalSlice);

  const disconnect = useCallback(() => {
    dispatch(resetBridge());
    dispatch(resetWallet());
    dispatch(resetModal());
    dispatch(logout());
    window.location.reload();
  }, [dispatch]);

  return (
    <Modal
      size="default"
      isShow={modalShowing === `TimeoutLogout`}
      title="Transaction Timeout"
      onClose={disconnect}
      explanation={
        <>
          For safe transactions, you will be automatically signed out because
          there is no service use for about an hour.
          <br />
          If the transaction is going on in the wallet, please cancel the
          transaction and proceed from the beginning.
          <br />
          (If you have proceeded to the approval stage of the Approve, there
          will be no additional approval for the approved amount.)
          <br />
          If you have completed all the transactions, please check the progress
          in History.
        </>
      }
      headerComponentExtended={<></>}
      footerComponent={<Button onClick={disconnect} title="OK" />}
    />
  );
};

export default ModalTimeoutLogout;
